import { Clipboard, Check } from "lucide-react";
import React, { useState } from "react";

interface CopyableContentProps {
  text: string;
  upperCase?: boolean;
  textClassName?: string;
  iconOnly?: boolean;
  alwaysShow?: boolean;
}

export function CopyableContent({ text, upperCase, textClassName, alwaysShow }: CopyableContentProps) {
  const [justCopied, setJustCopied] = useState(false);

  const formattedText = upperCase ? text.toUpperCase() : text;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(formattedText);

      setJustCopied(true);

      setTimeout(() => setJustCopied(false), 200);
    } catch {}
  }

  return (
    <span className="relative group cursor-default text-foreground text-sm" onClick={handleCopy}>
      {/* The entire span is now clickable */}
      <span className={`hover:opacity-70 transition-opacity duration-200 active:opacity-40 ${textClassName}`}>
        {formattedText}
      </span>
      {justCopied ? (
        <Check size={16} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" />
      ) : (
        <Clipboard
          size={16}
          className={`ml-1 text-muted-foreground ${alwaysShow ? "opacity-50" : "opacity-0"} group-hover:opacity-100 transition-opacity inline relative top-[-1px]`}
        />
      )}
    </span>
  );
}

export function CopyIcon({ text }: { text: string }) {
  const [justCopied, setJustCopied] = useState(false);

  const formattedText = text;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(formattedText);

      setJustCopied(true);

      setTimeout(() => setJustCopied(false), 200);
    } catch {}
  }

  return (
    <span className="relative group cursor-default" onClick={handleCopy}>
      {justCopied ? (
        <Check size={16} className="ml-1 text-green-600 transition-colors group-hover:opacity-100 inline" />
      ) : (
        <Clipboard
          size={16}
          className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity inline relative top-[-1px]"
        />
      )}
    </span>
  );
}
